export default "/images/error-img.png?352b9ab6d7d633e85325ef32e64a1cfa";